'use client'

import * as React from 'react'
import PropTypes from 'prop-types'
import { cn } from '@tiptap-ui/lib/tiptap-utils'
import '@tiptap-ui/components/tiptap-ui-primitive/card/card.scss'

const Card = React.forwardRef(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn('tiptap-card', className)} {...props} />
})
Card.displayName = 'Card'
Card.propTypes = {
  className: PropTypes.string,
}

const CardHeader = React.forwardRef(({ className, ...props }, ref) => {
  return (<div ref={ref} className={cn('tiptap-card-header', className)} {...props} />)
})
CardHeader.displayName = 'CardHeader'
CardHeader.propTypes = {
  className: PropTypes.string,
}

const CardBody = React.forwardRef(({ className, ...props }, ref) => {
  return (<div ref={ref} className={cn('tiptap-card-body', className)} {...props} />)
})
CardBody.displayName = 'CardBody'
CardBody.propTypes = {
  className: PropTypes.string,
}

const CardItemGroup = React.forwardRef(({ className, orientation = 'vertical', ...props }, ref) => {
  return (
    <div
      ref={ref}
      data-orientation={orientation}
      className={cn('tiptap-card-item-group', className)}
      {...props}
    />
  )
})
CardItemGroup.displayName = 'CardItemGroup'
CardItemGroup.propTypes = {
  className: PropTypes.string,
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),
}

const CardGroupLabel = React.forwardRef(({ className, ...props }, ref) => {
  return (<div ref={ref} className={cn('tiptap-card-group-label', className)} {...props} />)
})
CardGroupLabel.displayName = 'CardGroupLabel'
CardGroupLabel.propTypes = {
  className: PropTypes.string,
}

const CardFooter = React.forwardRef(({ className, ...props }, ref) => {
  return (<div ref={ref} className={cn('tiptap-card-footer', className)} {...props} />)
})
CardFooter.displayName = 'CardFooter'
CardFooter.propTypes = {
  className: PropTypes.string,
}

export { Card, CardHeader, CardFooter, CardBody, CardItemGroup, CardGroupLabel }
